export enum ManagedPermissions {
    DOWNLOADS = 'Downloads',
    CUSTOM_GRIDS = 'Custom Grids'
}
